import { Factory } from 'rosie';

Factory.define('MessageContentTypeLocation').attr('type', 'LOCATION');

Factory.define('MessageContentTypeLocationWithDefaults')
  .extend('MessageContentTypeLocation')
  .attr('location', {
    coordinates: {
      latitude: 39.0204,
      longitude: 122.101,
    },
  })
  .attr('buttons', []);



// WEBPACK FOOTER //
// ./factories/conversation_items/message_content_type_location_factory.js